import useCountTeamTasks from "../../swrCustomHooks/useCountTeamTasks"
import {useTranslation} from "react-i18next"
import arrowLeftBlackIcon from "../../assets/icon/arrow-left-black.svg"
import arrowLeftGrey from "../../assets/icon/arrow-left-grey.svg"
import arrowRightBlackIcon from "../../assets/icon/arrow-right-black.svg"
import arrowRightGrey from "../../assets/icon/arrow-right-grey.svg"
import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"

export default function TeamDashboardFooter({teamID}) {
    const {t} = useTranslation()
    const {nwDashboardContext, setNwDashboardAction} = useNwDashboardContext()
    const {countTeamTasks, isLoadingCountTeamTasks, isErrorCountTeamTasks} = useCountTeamTasks(teamID)
    const options = []

    try {
        var index = 1
        while (index < (Math.ceil(countTeamTasks / 8) + 1)) {
            options.push({value: index, label: index})
            index++
        }
    } catch {}

    const handlePage = (value) => {
        const selectPage = document.getElementById("selectPage")
        if (value === "-" && nwDashboardContext.teamPage > 1) {
            selectPage.value = parseInt(nwDashboardContext.teamPage - 1)
            setNwDashboardAction({type: "NW_DASHBOARD_SET_TEAM_PAGE", payload: {teamPage: parseInt(nwDashboardContext.teamPage) - 1}})
        } else if (value === "+" && nwDashboardContext.teamPage < Math.ceil(countTeamTasks / 8)) {
            selectPage.value = parseInt(nwDashboardContext.teamPage + 1)
            setNwDashboardAction({type: "NW_DASHBOARD_SET_TEAM_PAGE", payload: {teamPage: parseInt(nwDashboardContext.teamPage) + 1}})
        }
    }

    if (isErrorCountTeamTasks || isLoadingCountTeamTasks || countTeamTasks.message || countTeamTasks <= 8) return null
    return (
        <>
        <div className="SECTION TEAM-DASHBOARD-FOOTER">
            <div className="left-content">
                <select id="selectPage" name="selectPage" onChange={(e) => setNwDashboardAction({type: "NW_DASHBOARD_SET_TEAM_PAGE", payload: {teamPage: parseInt(e.target.value)}})}>
                    {options.map((option, index) => {
                        if ((index + 1) === nwDashboardContext.teamPage) {
                            return <option selected key={`option-${index}`} value={option.value}>{option.label}</option>
                        } else {
                            return <option key={`option-${index}`} value={option.value}>{option.label}</option>
                        }
                    })}
                </select>
                <p>sur {Math.ceil(countTeamTasks / 8)} page{Math.ceil(countTeamTasks / 8) >= 2 && "s"}</p>
            </div>
            <div className="right-content">
                <img src={(Math.ceil(countTeamTasks / 8) === 1 || nwDashboardContext.teamPage === 1) ? arrowLeftGrey : arrowLeftBlackIcon} alt="" onClick={() => handlePage("-")} title={t("Previous page")}/>
                <img src={(Math.ceil(countTeamTasks / 8) === 1 || nwDashboardContext.teamPage === Math.ceil(countTeamTasks / 8)) ? arrowRightGrey : arrowRightBlackIcon} alt="" onClick={() => handlePage("+")} title={t("Next page")}/>
            </div>
        </div>
        </>
    )
}